<template>
  <div id="BMIChartPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar :title="$route.query.name"></ActionBar>
    <div v-if="formulaDetail.Description !== null" class="font16px font-weight-bold mt-3">توضیحات:</div>
    <div v-if="formulaDetail.Description !== null" v-html="formulaDetail.Description"></div>
    <div v-if="iContentLoaded" class="row">
      <div v-if="timeRangeType === 3" class="col-12 col-sm-6 col-md-4">
        <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب سال:</span></div>
        <v-select
            v-model.number="selectedYear"
            :items="years"
            class="input-border"
            dense
            hide-details
            placeholder="انتخاب سال"
            solo
            @change="setYear">
        </v-select>
      </div>
      <div v-if="timeRangeType === 3" class="col-12 col-sm-6 col-md-4">
        <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب ماه:</span></div>
        <v-select
            ref='monthPicker'
            v-model.number="selectedMonth"
            :disabled="!showMonthPicker"
            :items="months"
            :menu-props="{value:openMonthPicker}"
            class="input-border"
            dense
            hide-details
            item-text="text"
            item-value="id"
            placeholder="انتخاب ماه"
            solo
            @change="setDate"
            @click="openMonthPicker  = true">
        </v-select>
      </div>
      <div v-if="timeRangeType === 4" class="col-12 col-sm-6 col-md-4">
        <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب روز:</span></div>
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            min-width="auto"
            offset-y
            transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="inputDate2"
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar"
                class="input-border"
                dense
                hide-details
                readonly
                solo></v-text-field>
          </template>
          <v-date-picker
              v-model="date2"
              locale="fa-ir"
              width="256"
              @input="inputDatePicker2"></v-date-picker>
        </v-menu>
      </div>
      <div v-if="timeRangeType === 1" class="col-12 col-sm-6 col-md-4">
        <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">از تاریخ:</span></div>
        <div>
          <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-left="100"
              min-width="auto"
              offset-y
              transition="scale-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="inputDate1"
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar"
                  class="input-border"
                  color="forth"
                  dense
                  hide-details
                  readonly
                  solo></v-text-field>
            </template>
            <v-date-picker
                v-model="date1"
                color="forth"
                locale="fa-ir"
                width="256"
                @input="inputDatePicker1"></v-date-picker>
          </v-menu>
        </div>
      </div>
      <div v-if="timeRangeType === 1" class="col-12 col-sm-6 col-md-4">
        <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">تا تاریخ:</span></div>
        <div>
          <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              min-width="auto"
              offset-y
              transition="scale-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="inputDate2"
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar"
                  class="input-border"
                  dense
                  hide-details
                  readonly
                  solo></v-text-field>
            </template>
            <v-date-picker
                v-model="date2"
                locale="fa-ir"
                width="256"
                @input="inputDatePicker2"></v-date-picker>
          </v-menu>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-md-2 text-left align-self-end">
        <v-btn block class="px-8" color="primary" rounded
               @click="search">
          جستجو
        </v-btn>
      </div>

    </div>

    <div class="row  mx-auto no-gutters p-0 mt-10">
      <div v-if="dataLoading" class="col-12 mt-10 col-md-6 col-lg-3 mx-auto text-center">
        در حال جستجو
        <v-progress-linear
            color="deep-purple accent-4"
            height="6"
            indeterminate
            rounded
        ></v-progress-linear>
      </div>
      <div v-else-if="isLoaded" class="col-12 p-0 p-md-5  mx-auto ">
        <div v-if="!hasReport" class="mx-2 mt-5">
          <div class="col-12">
            <v-alert
                border="bottom"
                class="text-center"
                color="forth"
                dark>
              گزارشی برای تاریخ انتخاب شده وجود ندارد.
            </v-alert>
          </div>
        </div>
        <div v-else>
          <MultipleBarChart v-if="isChartLoaded"
                            :chart-label="loadChartLabel()"
                            :chart-standard-data="loadChartStandardData()"
                            :chart-user-data="loadChartUSerData()"
                            :standard-label="'زمان استاندارد'"
                            :user-label="'زمان شما'"/>


<!--          <div class="col-12 mt-10">-->
<!--            <v-alert-->
<!--                border="bottom"-->
<!--                class="text-center"-->
<!--                outlined-->
<!--                type="warning"-->
<!--            >-->
<!--              برای هفته هایی که در نمودار وجود ندارد گزارشی ثبت نشده است.-->
<!--            </v-alert>-->
<!--          </div>-->
        </div>
      </div>
    </div>


    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <FooterMenu/>
  </div>
</template>

<script>
import ActionBar from "../../components/ActionBar";
import FooterMenu from "../../components/FooterMenu";
import moment from "moment-jalaali";
import MultipleBarChart from "../../components/MultipleBarChart";

export default {
  name: "ReportPage",
  components: {MultipleBarChart, FooterMenu, ActionBar},
  data: () => ({
    formulaDetail: {},
    selectedYear: null,
    selectedMonth: null,
    months: [
      {id: 1, text: 'فروردین'},
      {id: 2, text: 'اردیبهشت'},
      {id: 3, text: 'خرداد'},
      {id: 4, text: 'تیر'},
      {id: 5, text: 'مرداد'},
      {id: 6, text: 'شهریور'},
      {id: 7, text: 'مهر '},
      {id: 8, text: 'آبان '},
      {id: 9, text: 'آذر '},
      {id: 10, text: 'دی'},
      {id: 11, text: 'بهمن'},
      {id: 12, text: 'اسفند '},
    ],
    showMonthPicker: false,
    years: [],
    openMonthPicker: false,
    menu2: false,
    inputDate2: '',
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    inputDate1: '',
    menu1: false,
    date1: '',
    timeRangeType: null,
    isLoaded: false,
    showLoaderDialog: false,
    dataLoading: false,
    iContentLoaded: false,
    hasReport: false,
    isChartLoaded: false,
    chartLineSlopData: [],
    chartUserData: [],
    chartLabel: [],
    chartStandardData: []


  }),
  mounted() {
    this.getFormulaDetail()
    let year = this.$convertDate((new Date()).toISOString()).slice(0, 4)
    this.years.push(year - 1, parseInt(year))
    this.inputDate2 = this.$convertDate(this.date2)
    let current = new Date()
    current.setDate(current.getDate() - 365)
    this.date1 = current.toISOString().substr(0, 10)
    this.inputDate1 = this.$convertDate(this.date1)


  },
  methods: {
    getFormulaDetail() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("formulaId", this.$route.query.formulaId);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportCategoryManagement/FormulaDetail", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.formulaDetail = json
            this.timeRangeType = json.FormulaTimeRangeType
            this.iContentLoaded = true
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    setYear() {
      this.showMonthPicker = true
      // this.openMonthPicker = true
    },
    setDate() {
      this.openMonthPicker = null

      this.startDate = this.$chooseMonth(this.selectedMonth, this.selectedYear).startDate
      this.endDate = this.$chooseMonth(this.selectedMonth, this.selectedYear).endDate

    },
    inputDatePicker2() {
      this.menu2 = false
      this.inputDate2 = moment(this.date2).format('jYYYY/jMM/jDD')
    },
    inputDatePicker1() {
      this.menu1 = false

      this.inputDate1 = moment(this.date1).format('jYYYY/jMM/jDD')
    },
    search() {
      this.dataLoading = true;
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("formulaId", this.$route.query.formulaId);
      urlencoded.append("studentId", this.$getUserData().studentID);
      urlencoded.append("startDate", this.inputDate1);
      urlencoded.append("endDate", this.inputDate2);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportCategoryManagement/_ViewReport", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            this.chartUserData.push(json.CalculatedResult)
            // let lessons =this.stringToHTML(json.Result)
            var wrapper = document.createElement('div');
            wrapper.innerHTML = json.Result;
            let spans = wrapper.getElementsByTagName('span')
            let lessons = []
            for (let i = 0; i < spans.length; i++) {
              let attribute =spans[i].getAttribute('data-value').split(',')
              lessons.push({id :attribute[0],name:attribute[1]})
            }

            let standard = JSON.parse(json.StandardTime)


            for (let i = 0; i < lessons.length; i++) {
              for (let item in standard) {
                if (item === lessons[i].id) {
                  this.chartStandardData.push(standard[item])
                  this.chartLabel.push(lessons[i].name)
                }
              }

            }

            this.hasReport = true
            this.isChartLoaded = true
            this.dataLoading = false
            this.isLoaded = true
          })
          .catch(error => console.log('error', error));
    },
    loadChartStandardData() {
      let arr = this.chartStandardData;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
    loadChartUSerData() {
      let arr = this.chartUserData;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
    loadChartLabel() {
      let arr = this.chartLabel;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;
    },
    stringToHTML(str) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(str, 'text/html');
      return doc;
    }
  }
}
</script>

<style scoped>

</style>
